// src/pages/Dashboard/Layout.tsx
import React, { useState } from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import { router_config } from '../configs/route.config'
import InitialProfile from '../pages/Profile/InitialProfile'
import { Link } from 'react-router-dom'
// import { Link } from 'react-router-dom'

const sidebarLinks = [
  router_config.DASHBOARD,
  router_config.DASHBOARD_PROFILE,
  router_config.DASHBOARD_CERTIFICATE,
  // {
  //   ...router_config.DASHBOARD_FACILITATION,
  //   path: '/departments/facilitation',
  // },
  router_config.DASHBOARD_REPORTS,
  router_config.DASHBOARD_UPCOMING_PROGRAMS,
  router_config.DASHBOARD_SETTINGS,
]

const DashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [expanded, setExpanded] = useState<{ [key: string]: boolean }>({})
  // const { pathname } = useLocation()

  const toggleExpand = (key: string) =>
    setExpanded((prev) => ({ ...prev, [key]: !prev[key] }))

  return (
    <div className="min-h-screen flex bg-gray-100">
      {/* Sidebar */}
      <div
        className={`bg-white border-r w-72 p-5 space-y-6 fixed md:relative z-5 transform transition-transform duration-200 ease-in-out ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        } md:translate-x-0`}
      >
        {/* Profile Section */}

        <Link to="/dashboard/profile-details">
          {' '}
          <InitialProfile />
        </Link>

        {/* Sidebar Links */}
        <nav className="space-y-2">
          {sidebarLinks.map((link) => {
            // Render Dashboard: active-highlight only on exact /dashboard
            if (link.key === 'dashboard') {
              return (
                <NavLink
                  key={link.key}
                  to={link.path || ''}
                  end
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md text-sm font-medium ${
                      isActive
                        ? 'bg-linear-orange text-white'
                        : 'text-gray-700 hover:bg-gray-100'
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              )
            }
            if (link.key === 'dashboard_reports') {
              const isOpen = !!expanded[link.key]
              return (
                <div key={link.key} className="">
                  <button
                    type="button"
                    onClick={() => toggleExpand(link.key)}
                    className={
                      'w-full text-left px-4 py-2 rounded-md text-sm font-medium flex items-center justify-between text-gray-700 hover:bg-gray-100'
                    }
                  >
                    <span>{link.label}</span>
                    <span
                      className={`transition-transform ${isOpen ? 'rotate-90' : ''}`}
                    >
                      ▶
                    </span>
                  </button>
                  {isOpen && (
                    <div className="mt-1 ml-4 pl-3 border-l space-y-1">
                      {/* <NavLink
                        to={
                          router_config.DASHBOARD_TABLES_INCUBATION.path ||
                          '/dashboard/incubation'
                        }
                        className={({ isActive }) =>
                          `block px-3 py-2 rounded-md text-sm ${
                            isActive
                              ? 'bg-linear-orange text-white'
                              : 'text-gray-700 hover:bg-gray-100'
                          }`
                        }
                      >
                        Incubation Applications
                      </NavLink> */}
                      <NavLink
                        to={
                          router_config.DASHBOARD_TABLES_PROGRAMS.path ||
                          '/dashboard/programs'
                        }
                        className={({ isActive }) =>
                          `block px-3 py-2 rounded-md text-sm ${
                            isActive
                              ? 'bg-linear-orange text-white'
                              : 'text-gray-700 hover:bg-gray-100'
                          }`
                        }
                      >
                        Registered Programs
                      </NavLink>
                      <NavLink
                        to={
                          router_config.DASHBOARD_TABLES_FACILITATIONS.path ||
                          '/dashboard/facilitations'
                        }
                        className={({ isActive }) =>
                          `block px-3 py-2 rounded-md text-sm ${
                            isActive
                              ? 'bg-linear-orange text-white'
                              : 'text-gray-700 hover:bg-gray-100'
                          }`
                        }
                      >
                        Facilitation Services
                      </NavLink>
                    </div>
                  )}
                </div>
              )
            }

            return (
              <NavLink
                key={link.key}
                to={link.path || ''}
                className={({ isActive }) =>
                  `block px-4 py-2 rounded-md text-sm font-medium ${
                    isActive
                      ? 'bg-linear-orange text-white'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`
                }
              >
                {link.label}
              </NavLink>
            )
          })}
        </nav>
      </div>

      {/* Mobile Menu Button */}
      <button
        className="md:hidden fixed top-4 left-4 z-50 bg-white border p-2 rounded-md shadow-md"
        onClick={() => setSidebarOpen(!sidebarOpen)}
      >
        <svg
          className="h-6 w-6 text-gray-800"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d={sidebarOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'}
          />
        </svg>
      </button>

      {/* Main Content */}
      <div className="flex-1 ml-0 p-6 bg-white">
        <Outlet />
      </div>
    </div>
  )
}

export default DashboardLayout
